module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0086.png.5c05edfa.jpg";